import React, { useState } from 'react';
import '../Counter.css';

const AddAnniversaryForm = ({ onAdd, onCancel, style }) => {
  const [newAnniversary, setNewAnniversary] = useState({ title: '', date: '' });

  const handleSubmit = (e) => {
    e.preventDefault();
    if (newAnniversary.title && newAnniversary.date) {
      onAdd(newAnniversary);
      setNewAnniversary({ title: '', date: '' });
    }
  };

  return (
    <form className="add-form" onSubmit={handleSubmit}>
      <input
        type="text"
        placeholder="Anniversary title"
        value={newAnniversary.title}
        onChange={(e) => setNewAnniversary({...newAnniversary, title: e.target.value})}
        required
      />
      <input
        type="date"
        value={newAnniversary.date}
        onChange={(e) => setNewAnniversary({...newAnniversary, date: e.target.value})}
        required
      />
      <div className="form-actions">
        <button type="submit" className="save-btn">Save</button>
        <button type="button" className="cancel-btn" style={style} onClick={onCancel}>
          Cancel
        </button>
      </div>
    </form>
  );
};

export default AddAnniversaryForm;